import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { sendFeedback as sendFeedbackService } from '../../services/sendFeedback';
import * as persistentState from '../../utils/persistentState';
import { setStatusSucceed } from './setStatusSucceed';
import { setStatusFailed } from './setStatusFailed';
import { generateFormKey } from '../formKey';
import { updateFormInitialState } from '../formInitialState';
export function sendFeedback(parameters) {
  var _ref;
  return function (_x, _x2, _x3) {
    return (_ref = _ref || _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState, context) {
      var _getState, referenceLink, result;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _getState = getState(), referenceLink = _getState.referenceLink;
            _context.next = 3;
            return sendFeedbackService(context, _objectSpread(_objectSpread({}, parameters), {}, {
              referenceLink: referenceLink
            }));
          case 3:
            result = _context.sent;
            if (!(result.status === 'succeed')) {
              _context.next = 12;
              break;
            }
            dispatch(setStatusSucceed(result));
            // Чистим localStorage
            persistentState.clear();
            // Обновляем изначальное состояние формы, так как все данные отправили, нужно поставить форму в состояние,
            // в котором она должна быть до влияния пользователя.
            // То есть кидаем сюда только те поля, которые передаются в параметрах виджета, либо пустой объект.
            _context.next = 9;
            return dispatch(updateFormInitialState(context.internalPreloadedFormState || {}));
          case 9:
            // Устанавливаем новый ключ формы, чтобы спровоцировать её перерисовку и сброс в изначальное состояние
            // Таймаут не трогать, без него получаем memory leak
            setTimeout(function () {
              return dispatch(generateFormKey());
            });
            _context.next = 13;
            break;
          case 12:
            dispatch(setStatusFailed(result.errorMessage));
          case 13:
            return _context.abrupt("return", result);
          case 14:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))).apply(this, arguments);
  };
}